import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="theme"
export default class extends Controller {
  static values = {
    primary: { type: String, default: "#1e3a5f" },
    secondary: { type: String, default: "#f5f7fb" },
    accent: { type: String, default: "#0f8b8d" }
  }

  connect() {
    this.applyColors()
  }

  applyColors() {
    const root = document.documentElement
    root.style.setProperty('--primary-color', this.primaryValue)
    root.style.setProperty('--secondary-color', this.secondaryValue)
    root.style.setProperty('--accent-color', this.accentValue)

    // Also set gradient variables
    root.style.setProperty('--gradient', `linear-gradient(135deg, ${this.primaryValue} 0%, ${this.secondaryValue} 100%)`)
    root.style.setProperty('--gradient-gold', `linear-gradient(135deg, ${this.secondaryValue} 0%, ${this.accentValue} 100%)`)
  }

  primaryValueChanged() {
    this.applyColors()
  }

  secondaryValueChanged() {
    this.applyColors()
  }

  accentValueChanged() {
    this.applyColors()
  }
}
